import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import { SelectField, TextField } from 'views/components/core/ReduxForm';
import Modal from 'react-bootstrap4-modal';
import LoadingButton from 'views/components/LoadingButton';
import { Button } from '@kambria/kambria-lego';
import { requestWithdrawKWallet } from 'redux/actions/kWallet.action';
import * as types from 'redux/actions/actionTypes';
import enums from 'helpers/const';

const FORM_NAME = 'requestWithdraw';
const { KAT, KYTE } = enums.WITHDRAW_TYPE;
const required = (value) => (value ? undefined : 'Required');
const GAS_FEE = { [KAT]: 1500, [KYTE]: 15 };

class WithdrawModal extends Component {
  state = {
    gasFee: 0,
    totalAmount: 0,
  };

  submitRequest = (value) => {
    const { gasFee } = this.state;
    const { kWallet, requestWithdrawKWallet: requestWithdraw } = this.props;
    const { type, amount, address } = value;
    const errors = {};
    let kWalletAmount = 0;
    if (!Number(amount)) errors.amount = 'Invalid Number';
    if (type.value === KAT) kWalletAmount = kWallet.katAmount;
    if (type.value === KYTE) kWalletAmount = kWallet.kyteAmount;
    if (Number(amount) + Number(gasFee) > kWalletAmount) {
      errors.amount = `The ${type.value} in your Wallet is not enough`;
    }
    if (Object.keys(errors).length) {
      throw new SubmissionError(errors);
    }
    const paramsRequest = {
      amount: Number(amount),
      type: type.value,
      address: address.replace(/\s+/g, ' ').trim().toLowerCase(),
      gasFee,
    };
    requestWithdraw(paramsRequest);
  };

  closeModal = () => {
    const { toggleModal, resetSubmitRequest } = this.props;
    toggleModal(false);
    setTimeout(function () {
      resetSubmitRequest();
    }, 400);
  };

  onClickConnect = (e) => {
    e.preventDefault();
    this.props.connectWallet();
  };

  onChangeType = (e) => {
    const gas = GAS_FEE[e.value];
    this.setState({ gasFee: gas });
  };

  onChangeAmount = (e) => {
    const amount = Number(e.target.value);
    this.setState({ totalAmount: amount + this.state.gasFee });
  };

  render() {
    const { gasFee, totalAmount } = this.state;
    const { handleSubmit, visibleModal, kWallet } = this.props;
    const { sendingRequest, requestSuccess, requestError } = kWallet;
    return (
      <Modal className="kambria-modal codebase-modal" visible={visibleModal} dialogClassName="modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <button type="button" className="close-button" onClick={this.closeModal} />
            <div>
              <span className="title d-block text-center mt-4" style={{ color: '#13CDAC', fontSize: '24px' }}>
                Withdraw
              </span>
              {requestSuccess ? (
                <div className="content">
                  <p>
                    Your request has been sent to the administrator, when the request is processed, an email will notify
                    you.
                  </p>
                  <div style={{ textAlign: 'center' }}>
                    <Button type="primary" onClick={this.closeModal}>
                      OK
                    </Button>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit(this.submitRequest)}>
                  <div style={{ marginTop: 15, marginBottom: 15 }}>
                    <Button type="primary" size="sm" onClick={this.onClickConnect}>
                      Connect to other wallet
                    </Button>
                  </div>
                  <div className="content">
                    <div>
                      <Field
                        name="type"
                        component={SelectField}
                        options={[KAT, KYTE].map((v) => ({ label: v, value: v }))}
                        defaultValue={KAT}
                        selectProps={{
                          isMulti: false,
                          placeholder: 'Select type...',
                        }}
                        validate={required}
                        onChange={this.onChangeType}
                      />
                    </div>
                    <br />
                    <div>
                      <Field
                        name="amount"
                        placeholder="Amount"
                        component={TextField}
                        validate={required}
                        onChange={this.onChangeAmount}
                      />
                    </div>
                    <div>
                      <Field name="address" placeholder="Address" component={TextField} validate={required} />
                    </div>
                    <br />
                    <p>Withdraw fee: {gasFee}</p>
                    <p>Total amount: {totalAmount}</p>
                    <p>Your withdrawal request will be sent to admin.</p>
                    {requestError && <p style={{ color: 'red' }}>{requestError}</p>}
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <LoadingButton loading={sendingRequest} type="submit" variant="primary">
                      Withdraw
                    </LoadingButton>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = ({ kWallet, blockchain, user }) => {
  return {
    kWallet: {
      ...kWallet,
      katAmount: user.katAmount,
      kyteAmount: user.kyteAmount,
    },
    account: blockchain.account,
    initialValues: {
      address: blockchain.account,
    },
  };
};

const mapDispatchToProps = (dispatch) => ({
  requestWithdrawKWallet: (params) => dispatch(requestWithdrawKWallet(params)),
  resetSubmitRequest: () => dispatch({ type: types.RESET_SUBMIT_REQUEST }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: FORM_NAME,
    asyncBlurFields: [],
    enableReinitialize: true,
  })(WithdrawModal),
);
